import { supabase } from "index";
import { apiRequest } from "utils/api";
import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { CURRENT_USER_QUERY_KEY } from "../queries/use-current-user-query";

export const useUploadAvatar = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ image, userId }: { image: File; userId: string }) => {
      const { data: uploadData, error: uploadError } = await supabase.storage
        .from("avatars")
        .upload(userId, image, {
          contentType: image.type,
          upsert: true,
        });

      if (uploadError || !uploadData) {
        throw uploadError;
      }

      await apiRequest("/supabase/users/update", {
        values: {
          avatar: uploadData.path,
        },
      });

      return uploadData;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CURRENT_USER_QUERY_KEY });
    },
  });
};
